export function getOpsWorkspaceMeta(currentPath) {
  const isDashboardRoute = currentPath === '/my-dashboard';
  const isScorecardRoute = currentPath === '/location-scorecard';
  const isGoalsRoute = currentPath === '/goals';
  const isStationRoute = currentPath === '/station-summary';
  const isRequestsRoute = currentPath === '/requests-calendar';

  return {
    heroDescription: 'This workspace pairs your assigned performance view with a broader location summary so you can understand operating context without exposing unrestricted peer details.',
    heroTitle: isGoalsRoute
      ? 'Goals'
      : isScorecardRoute
        ? 'Location Scorecard'
        : isStationRoute
          ? 'Location Summary'
          : isRequestsRoute
            ? 'Requests & Calendar'
            : 'My Dashboard',
    isDashboardRoute,
    isGoalsRoute,
    isRequestsRoute,
    isScorecardRoute,
    isStationRoute
  };
}

export function getAirportWorkspaceMeta(currentPath) {
  const isStationDashboardRoute = currentPath === '/station-dashboard';
  const isScorecardRoute = currentPath === '/location-scorecard';
  const isGoalsRoute = currentPath === '/goals';
  const isOpsManagersRoute = currentPath === '/ops-managers';
  const isRequestsCalendarRoute = currentPath === '/requests-calendar';

  return {
    heroDescription: 'This workspace focuses on the current location, the people assigned to it, and the scorecards you are allowed to review or update.',
    heroTitle: isGoalsRoute
      ? 'Goals'
      : isScorecardRoute
        ? 'Location Scorecard'
        : isOpsManagersRoute
          ? 'People & Access'
          : isRequestsCalendarRoute
            ? 'Requests & Calendar'
            : 'Location Dashboard',
    isGoalsRoute,
    isOpsManagersRoute,
    isRequestsCalendarRoute,
    isScorecardRoute,
    isStationDashboardRoute
  };
}
